import * as PubSub from "pubsub-js";

export default class InternalEventBus {
  static subscribe(event, eventHandler) {
    return PubSub.subscribe(event, (m, d) => eventHandler(d));
  }

  static publish(event, eventPayload) {
    PubSub.publish(event, eventPayload);
  }

  static unsubscribe(token) {
    PubSub.unsubscribe(token);
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/internalEventBus.js